import { NgModule } from '@angular/core';

import { NoteFactory } from './note-factory';

@NgModule({
  providers: [NoteFactory]
})
export class NoteFactoryModule {}
